import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["value", "placeholder"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M1.58517 0.292894C1.22254 -0.0976306 0.634601 -0.0976305 0.271972 0.292894C-0.0906577 0.683418 -0.0906577 1.31658 0.271972 1.70711L5.8434 7.70711C6.19494 8.08568 6.76098 8.09893 7.12746 7.73715L12.6989 2.23715C13.0769 1.86396 13.1025 1.23139 12.7559 0.824276C12.4094 0.417157 11.822 0.389654 11.444 0.762846L6.52792 5.61586L1.58517 0.292894Z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Poper = _resolveComponent("Poper")!

  return (_openBlock(), _createElementBlock("div", {
    ref: "drop",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleopen && _ctx.handleopen(...args))),
    class: _normalizeClass(['r-select',_ctx.showmenu?'active':''])
  }, [
    _createElementVNode("input", {
      value: _ctx.modelValue,
      placeholder: _ctx.placeholder,
      readonly: ""
    }, null, 8, _hoisted_1),
    (_openBlock(), _createElementBlock("svg", {
      class: _normalizeClass(_ctx.showmenu ? 'revert' : ''),
      width: "13",
      height: "8",
      viewBox: "0 0 13 8",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, _hoisted_3, 2)),
    _createVNode(_component_Poper, {
      left: _ctx.left,
      top: _ctx.top,
      hide: !_ctx.showmenu
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "dropdown", {}, () => [
          _createElementVNode("div", {
            style: _normalizeStyle({width:`${_ctx.width}`}),
            onClick: _withModifiers(()=>{}, ["stop"]),
            class: "r-ul r-ul-select"
          }, [
            _createElementVNode("div", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "r-drop-item r-drop-item-select",
                  onClick: ($event: any) => (_ctx.handleclick(item.key || item)),
                  key: item.key || item
                }, [
                  _createElementVNode("span", null, _toDisplayString(item.title || item), 1)
                ], 8, _hoisted_5))
              }), 128))
            ])
          ], 12, _hoisted_4)
        ])
      ]),
      _: 3
    }, 8, ["left", "top", "hide"])
  ], 2))
}